import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { LOADING } from "src/store/actions";
import instance from "src/store/axios";


class BackendUserService {
  private dispatch = useDispatch();

  public async sendResetPasswordEmail(userId, email): Promise<boolean> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      await instance.post(`/${process.env.REACT_APP_ENDPOINT_VERSION}/admin/${userId}/send-reset-password-email`, { userId, email });
      toast.success("Password reset email sent successfully");
      return true;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/home/customers-list`);
      return false;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }

  public async forceUpdatePassword(userId): Promise<boolean> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      await instance.post(`/${process.env.REACT_APP_ENDPOINT_VERSION}/user/${userId}/force-reset-password`, { userId });
      return true;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/home/customers-list`);
      return false;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }
}

export default BackendUserService;
